import { render, staticRenderFns } from "./Form3Table.vue?vue&type=template&id=8c3c2350"
import script from "./Form3Table.vue?vue&type=script&lang=ts"
export * from "./Form3Table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports